import { render, staticRenderFns } from "./TransmittedSettlement.vue?vue&type=template&id=51d4d46c"
import script from "./TransmittedSettlement.vue?vue&type=script&lang=js"
export * from "./TransmittedSettlement.vue?vue&type=script&lang=js"
import style0 from "./TransmittedSettlement.vue?vue&type=style&index=0&id=51d4d46c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports